const SEO_VARIABLES = {
  title: 'Web &amp; Mobile App Design and Development Company',
  description: 'Web &amp; Mobile App Design and Development Company',
}

export default SEO_VARIABLES
